/** Promo discount math shared by the pay dialog (and mirrored server-side in
 * functions/api/checkout.js, which runs in the Cloudflare runtime and can't
 * import from src/). Keep the two in sync. */
export interface PromoDiscount {
  type: string;
  value: number | null;
}

/** Discounted amount in minor units. 'free' => 0; 'percent' => rounded
 * reduction. Never below 0. Unknown types return the amount unchanged. */
export function applyPromoDiscount(amount: number, promo: PromoDiscount | null): number {
  if (!promo) return amount;
  if (promo.type === "free") return 0;
  if (promo.type === "percent" && promo.value) {
    return Math.max(0, Math.round(amount * (1 - promo.value / 100)));
  }
  return amount;
}
